/** Format a value for `<input type="date">` (calendar date, no UTC day shift). */
export function formatDateForInput(
  value: string | Date | null | undefined,
): string {
  if (value == null || value === "") return "";

  if (value instanceof Date) {
    if (Number.isNaN(value.getTime())) return "";
    return toLocalYmd(value);
  }

  const s = String(value).trim();
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s;

  // API date-times: keep the calendar date from the string (admin picked YYYY-MM-DD).
  const datePart = s.match(/^(\d{4}-\d{2}-\d{2})/);
  if (datePart) return datePart[1];

  const parsed = new Date(s);
  if (Number.isNaN(parsed.getTime())) return "";
  return toLocalYmd(parsed);
}

/** Today's date in local timezone for date inputs. */
export function formatTodayForDateInput(): string {
  return toLocalYmd(new Date());
}

/** Yesterday (local) — default early bird end date for new events. */
export function formatYesterdayForDateInput(): string {
  const d = new Date();
  d.setDate(d.getDate() - 1);
  return toLocalYmd(d);
}

function toLocalYmd(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}
